module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmSU5fBBc4AMP6lQ.c0cc9c92.woff2";